import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
  },
  columnWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 16,
    color: theme.palette.primary.light,
  },
  fieldStatus: {
    display: 'flex',
    flexDirection: 'row',
    margin: '8px 0',
    alignItems: 'center',
    '&>span:nth-child(1)': {
      opacity: '0.72',
      paddingRight: theme.spacing(1.5),
    },
    '&>span:nth-child(2)': {
      opacity: 1,
    },
  },
  field: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 16,
    color: theme.palette.primary.light,
    '&:not(:last-of-type)': { paddingBottom: theme.spacing(3) },
    '&>span:nth-child(1)': {
      opacity: '0.72',
      paddingRight: theme.spacing(1.5),
    },
    '&>span:nth-child(2)': {
      opacity: 1,
    },
  },
  row: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
    alignItems: 'center',
  },
  column: {
    color: theme.palette.primary.light,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    '& *': {
      // paddingBottom: theme.spacing(1.5),
    },
    '& a': {
      display: 'block',
      fontSize: 16,
      color: theme.palette.primary.light,
    },
  },
  tableColor: {
    padding: theme.spacing(4),
    background: '#75757544',
  },
  subTitle: {
    opacity: '0.72',
  },
  buttonWrap: {
    justifyContent: 'flex-end',
  },
  buttonWidth: {
    width: '200px',
    marginTop: 0,
  },
  deleteIcon: {
    color: '#A9544B',
    '&:hover': {
      color: theme.palette.error.main,
    },
  },
  headerPosition: {
    alignItems: 'center',
    marginBottom: theme.spacing(4),
  },
}))
